import React from 'react';
import { PropTypes } from 'prop-types';
import { Link } from 'react-router-dom';

import RedirectButton from 'components/Common/Buttons/RedirectButton';
import ErrorGraphic from '../ErrorGraphic';

const NotFoundPage = ({ caption }) => (
  <div>
    <ErrorGraphic />
    <div className="message-404-box">
      <h1>404</h1>
      <p>{ caption }</p>
      <div className="buttons-con">
        <div className="action-link-wrap">
          <RedirectButton
            to="/"
            title="Go back"
            className="btn link-go-back"
            redirectBack
          />
          <Link to="/" className="link-button">Go to home page</Link>
        </div>
      </div>
    </div>
  </div>
);

NotFoundPage.propTypes = {
  caption: PropTypes.string
};

NotFoundPage.defaultProps = {
  caption: 'The page was not found'
};

export default NotFoundPage;
